// extracted by mini-css-extract-plugin
export var compactFilters = "_c6-4";
export var detailImage = "_c6-1";
export var dropdownContainer = "_c6-2";
export var imageContainer = "_c6-0";
export var selectedCard = "_c6-3";